import styled, { css } from 'styled-components';

export const LabelsWrapper = styled.div<{ $mt: number; $isThreeLabels?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ $mt }) => $mt}px;
  ${({ $isThreeLabels }) =>
    $isThreeLabels &&
    css`
      gap: 12px;
    `}
`;

export const TrustItem = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.custom?.trustLabelsBg || '#FEF3EB'};
    border-radius: 4px;
    width: calc(50% - 6px);
    padding: 4px;
    font-weight: 700;
    font-size: 10px;
    color: ${({ theme }) => theme.custom?.primary || '#F2994A'};

    svg {
      ${({ theme }) => (theme.isRtl ? 'margin-left: 6px;' : 'margin-right: 6px;')}
    }
  `,
);
